import { render } from "./ComplianceSubmissionDialog.vue?vue&type=template&id=61da388e&scoped=true"
import script from "./ComplianceSubmissionDialog.vue?vue&type=script&lang=js"
export * from "./ComplianceSubmissionDialog.vue?vue&type=script&lang=js"

import "./ComplianceSubmissionDialog.vue?vue&type=style&index=0&id=61da388e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61da388e"]])

export default __exports__